import type { Auth } from "firebase/auth";
import * as firebaseCore from "./firebase-core";

type FirebaseAuthModule = typeof import("firebase/auth");

type FirebaseAuthLoadResult = {
  firebaseAuth: FirebaseAuthModule;
  auth: Auth | null;
  isConfigured: boolean;
};

let cachedAuthPromise: Promise<FirebaseAuthLoadResult> | null = null;

export const loadFirebaseAuth = (): Promise<FirebaseAuthLoadResult> => {
  if (!cachedAuthPromise) {
    cachedAuthPromise = (async () => {
      const firebaseAuth = await import("firebase/auth");

      if (!firebaseCore.isConfigured) {
        return { firebaseAuth, auth: null, isConfigured: firebaseCore.isConfigured };
      }
      const auth = await firebaseCore.getAuthInstance();
      return {
        firebaseAuth,
        auth: auth ?? null,
        isConfigured: firebaseCore.isConfigured,
      };
    })();
  }
  return cachedAuthPromise;
};
